import React, { useState } from 'react';
import MouseLightEffect from './MouseLightEffect';
import { useTrack } from '../analytics/TrackingContext';

function GastoMensualCarga({ setResultado, nombreVehiculo, setNombreVehiculo }) {
  const { trackEvent } = useTrack();
  const [consumoVehiculo, setConsumoVehiculo] = useState('');
  const [distanciaMensual, setDistanciaMensual] = useState('');
  const [precioKwh, setPrecioKwh] = useState('');
  const [resultado, setResultadoLocal] = useState(null);
  const [animarResultado, setAnimarResultado] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [editandoNombre, setEditandoNombre] = useState(true);
  const [nombreTemporal, setNombreTemporal] = useState('');

  const confirmarNombre = () => {
    if (nombreTemporal.trim()) {
      setNombreVehiculo(nombreTemporal.trim());
      setEditandoNombre(false);
    }
  };

  const calcularGasto = () => {
    if (!consumoVehiculo || !distanciaMensual || !precioKwh) {
      setErrorMessage('Por favor, introduce todos los datos.');
      setResultadoLocal(null);
      setResultado(null);
      return;
    }

    const gasto = (parseFloat(consumoVehiculo) * parseFloat(distanciaMensual) * parseFloat(precioKwh)) / 100;
    setResultadoLocal(gasto);
    setResultado(gasto);
    setAnimarResultado(true);
    setErrorMessage('');
    trackEvent('calculation', 'gasto_carga');
  };

  return (
    <MouseLightEffect>
    <div className="section-container">
      {editandoNombre ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
          <label htmlFor="nombre_elec_input" style={{ whiteSpace: 'nowrap', fontSize: '0.85rem' }}>Introduce el nombre del VE</label>
          <input
            id="nombre_elec_input"
            type="text"
            value={nombreTemporal}
            onChange={(e) => setNombreTemporal(e.target.value)}
            placeholder="Nombre VE"
            onKeyDown={(e) => { if (e.key === 'Enter') confirmarNombre(); }}
            style={{ flex: 2, minWidth: '180px' }}
          />
          <button className="calc" onClick={confirmarNombre} style={{ padding: '6px 14px', fontSize: '1.2rem', lineHeight: 1 }}>+</button>
        </div>
      ) : (
        <div style={{ textAlign: 'center', marginBottom: '8px' }}>
          <button className="reset-button" style={{ fontSize: '0.8rem', padding: '4px 10px' }} onClick={() => { setNombreTemporal(nombreVehiculo); setEditandoNombre(true); }}>Cambiar Nombre del Vehículo</button>
        </div>
      )}
      <h2>Coste de Electricidad</h2>
      {nombreVehiculo && !editandoNombre && <h4 style={{ textAlign: 'center', margin: '4px 0 12px', fontStyle: 'italic' }}>{nombreVehiculo}</h4>}
      
      <div className="input">
        <label htmlFor="consumokw_input">Consumo del Vehículo (kWh/100 Km): </label>
        <input
          id="consumokw_input"
          type="number"
          value={consumoVehiculo}
          onChange={(e) => setConsumoVehiculo(e.target.value)}
          placeholder="Ej: 15"
          min={0}
        />
      </div>
      
      <div className="input">
        <label htmlFor="dist_elec_input">Distancia Recorrida (Km): </label>
        <input
          id="dist_elec_input"
          type="number"
          value={distanciaMensual}
          onChange={(e) => setDistanciaMensual(e.target.value)}
          placeholder="Ej: 1000"
          min={0}
        />
      </div>

      <div className="input">
        <label htmlFor="preciokw_input">Precio del kWh <br></br>(Euros): </label>
        <input
          id="preciokw_input"
          type="number"
          value={precioKwh}
          onChange={(e) => setPrecioKwh(e.target.value)}
          placeholder="Ej: 0.15"
          min={0}
        />
      </div>

      <div className="button">
        <button className="calc" onClick={calcularGasto}>Calcular Gasto</button>
      </div>

      {errorMessage && (
          <div className="error-message" role="alert" aria-live="assertive">
          <p>{errorMessage}</p>
        </div>
      )}

      {resultado !== null && (
          <div className={`res ${animarResultado ? 'resultado-animado' : ''}`} aria-live="polite" aria-atomic="true">
          <p>Gasto mensual al cargar la batería:</p>
          <p><strong>{resultado.toFixed(2)} Euros</strong></p>
          <div className="icon-container">
            <img src={`${process.env.PUBLIC_URL}/images/cable-de-carga-coche-el-ctrico01.png`} alt="Icono de Potencia" className="cable-de-carga-mennekes" />
          </div>
        </div>
      )}
    </div>
    </MouseLightEffect>
  );
}

export default GastoMensualCarga;

